export const CUSTOM_NOISE_SUPPRESSION = 'CUSTOM_NOISE_SUPPRESSION';
export const SELECT_VISITOR_MUTE_STATE = 'SELECT_VISITOR_MUTE_STATE';
export const CUSTOM_NOISE_SUPPRESSION_TYPE = 'CUSTOM_NOISE_SUPPRESSION_TYPE';
export const UPDATE_IDS_VALUES_NOISE_SUPPRESSION = 'UPDATE_IDS_VALUES_NOISE_SUPPRESSION';
export const SELECTED_LANG_TRANSCRIPTION = 'SELECTED_LANG_TRANSCRIPTION';
export const SELECTED_AUDIO_STATE = 'SELECTED_AUDIO_STATE';
export const SELECTED_VIDEO_STATE = 'SELECTED_VIDEO_STATE';
export const CUSTOM_AUTOSTART_TRANSCRIPTION = 'CUSTOM_AUTOSTART_TRANSCRIPTION';
export const CUSTOM_AUTOSTART_RECORDING = 'CUSTOM_AUTOSTART_RECORDING';
export const CUSTOM_PRE_JOIN_SCREEN = 'CUSTOM_PRE_JOIN_SCREEN';
export const CUSTOM_PRE_JOIN_SCREEN_EXTERNAL = 'CUSTOM_PRE_JOIN_SCREEN_EXTERNAL';
export const AUTO_PIP = 'AUTO_PIP';
